var collapsible_list_component_rtlignore_default = {
  "ltr": "-CAx7",
  "rtl": "l25Qe",
  "iconContainer": "_2J5X0",
  "icon": "DIBiY",
  "isExpanded": "LOYUG",
  "listDimensions": "-D23c"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
